import React, { useCallback } from 'react';
import { getIn } from 'formik';

import { TextField } from '../../text-field';
import { FieldElementPropTypes } from '../propTypes';
import { buildTooltipAdornment } from './tooltip-adornment';

const StringField = ({
  field: {
    id,
    name,
    label,
    mode,
    value,
    optional,
    onChange: customOnChange,
    tooltipText,
    tooltipLabel,
    InputProps,
    ...props
  },
  ctx: { handleChange, touched, errors, classes, setFieldTouched }
}) => {
  const onChange = useCallback(
    (e) => {
      handleChange(e);
      setFieldTouched(id, true, false);
      if (customOnChange) {
        customOnChange(value, id || name);
      }
    },
    [handleChange, setFieldTouched, id, customOnChange, value, name]
  );
  const tooltipAdornment = buildTooltipAdornment(tooltipText, tooltipLabel);
  return (
    <TextField
      key={id}
      id={id}
      name={name || id}
      label={label}
      value={value || ''}
      onChange={onChange}
      error={getIn(touched, name || id) && !!getIn(errors, name || id)}
      helperText={getIn(touched, name || id) && getIn(errors, name || id)}
      mode={mode}
      fullWidth
      classes={classes[id]}
      multiline
      minRows={6}
      maxRows={6}
      {...props}
      InputProps={{
        ...(tooltipAdornment ? { endAdornment: tooltipAdornment } : {}),
        ...(InputProps || {})
      }}
    />
  );
};

StringField.propTypes = FieldElementPropTypes;

export default StringField;
